import ShowMore from "./showMore";

export default ShowMore;
